/**
 * Get local storage value for the key.
 *
 * @param key whose value to get.
 * @param isObject
 * @param fallback fallback value if key doesn't exist.
 */
export function get(
  key: string,
  isObject: boolean,
  fallback: string | number | boolean | null | Record<string, string | number | boolean | null>
): string | number | boolean | null | Record<string, string | number | boolean | null> {
  if (isObject) {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  }

  return localStorage.getItem(key) || fallback;
}

/**
 * Set local storage value for the key.
 *
 * @param key whose Value to set.
 * @param value Value to set.
 */
export function set(
  key: string,
  value: string | number | boolean | Record<string, string | number | boolean | null>
): void {
  if (value instanceof Object) {
    localStorage.setItem(key, JSON.stringify(value));
    return;
  }

  localStorage.setItem(key, String(value));
}

/**
 * Remove the key value pair in local storage.
 *
 * @param key
 */
export function remove(key: string): void {
  localStorage.removeItem(key);
}
